var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[(_vm.plantaSelected !== 'all')?_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          path: '/dashboard',
          icon: 'ni ni-chart-pie-35 text-primary',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"opened":"","link":{
          name: 'Gestión de Activos',
          icon: 'ni ni-app text-primary',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Todos los Equipos',
            path: '/activo-management/list-activos',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'EPIs',
            path: '/activo-management/list-epis',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Herramientas',
            path: '/activo-management/list-herramientas',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Dispositivos de Anclaje',
            path: '/activo-management/list-anclaje',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Fin Vida Útil',
            path: '/activo-management/list-fin-vida-util',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Retirados',
            path: '/activo-management/list-retirados',
          }}})],1),(_vm.plantaSelected !== 'all')?[(_vm.plantaSelected === '172')?_c('sidebar-item',{attrs:{"opened":"","link":{
          name: 'Trazabilidad',
          icon: 'ni ni-delivery-fast text-primary',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Albaranes entrega',
            path: '/albaran-management/list-albaranes',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Partes',
            path: '/partes',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Incidencias albaranes',
            path: '/albaran-management/incidencias-albaranes',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Keikaku',
            path: '/keikaku',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Poal',
            path: '/poal',
          }}})],1):_vm._e(),(_vm.plantaSelected === '134' || _vm.plantaSelected === '15')?_c('sidebar-item',{attrs:{"opened":"","link":{
            name: 'Inspección Visual',
            path: '/inspeccion-visual/list',
            icon: 'ni ni-zoom-split-in text-primary',
          }}}):_vm._e(),(_vm.plantaSelected === '134')?_c('sidebar-item',{attrs:{"link":{
            name: 'Vida útil modelos',
            path: '/modelo-management/vida-util-modelos',
            icon: 'ni ni-watch-time text-primary',
          }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Empleados',
          path: '/user-management/list-employees',
          icon: 'ni ni-single-02 text-primary',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Incidencias',
          path: '/incidencia-management/list-incidencias',
          icon: 'ni ni-support-16 text-primary',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Mensajes',
          icon: 'ni ni-notification-70 text-primary',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Enviados',
            path: '/notificacion-management/list-notificaciones-enviadas',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Recibidos',
            path: '/notificacion-management/list-notificaciones',
          }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Ajustes',
          icon: 'ni ni-settings-gear-65 text-primary',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Usuarios',
            path: '/user-management/list-users',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Plantas',
            path: '/empresa-management/list-empresa',
          }}})],1)]:_vm._e()],2)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }